import { createFileRoute, redirect } from '@tanstack/react-router';
import { formatLevelGDID } from '~/util';
import { levelsQuery } from '~/util/queries/public/levels';

export const Route = createFileRoute('/list/')({
    loaderDeps: ({ search: { list } }) => ({ list }),
    loader: async ({ deps: { list }, context: { queryClient } }) => {
        const first_level = (
            await queryClient.fetchQuery(levelsQuery({ list }))
        )?.[0];

        if (first_level) {
            throw redirect({
                to: '/list/$levelid',
                params: {
                    levelid: formatLevelGDID(first_level),
                },
                replace: true,
            });
        }
    },
    component: () => null,
});
